const colors = {
  actions: {
    async getColors(context) {
      return await context.dispatch("getRequest", {
        api: "ext_web/colors",
      });
    },
  },
};

export default colors;
